import { makeAutoObservable } from "mobx";
import type { apiTypes } from "../../services/APIService";
import { api } from "../../services";
import { AttributeShelf, LoaderShelf } from "../../shelves";

export class Store {
	public preSimulation = new AttributeShelf<apiTypes.PreSimulation | null>(null);
	public balance = new AttributeShelf(3166.83);
	public birthMonth = new AttributeShelf(9);
	public loader = new LoaderShelf();

	constructor(balance: number, birthMonth: number) {
		this.balance.set(balance);
		this.birthMonth.set(birthMonth);

		makeAutoObservable(this);
	}

	public fetchPreSimulation = async (): Promise<void> => {
		if (this.loader.isLoading) {
			return;
		}

		try {
			this.loader.start();
			const preSimulation = await api.getPreSimulation(this.balance.value, this.birthMonth.value);
			this.preSimulation.set(preSimulation);
		} catch (e) {
			window.console.error(e);
		} finally {
			this.loader.end();
		}
	};

}
